import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { selectUser } from '../ngrx/data.reducer';

@Injectable({
  providedIn: 'root',
})
export class FanGuard {
  constructor(
    private router: Router,
    private store: Store
  ) { }

  canActivate(state: RouterStateSnapshot): boolean {
    let userDetails: any;
    this.store
      .select(selectUser)
      .pipe(take(1), distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe((user) => {
        userDetails = user;
      });
    if (!userDetails || !userDetails.userTypeId) {
      this.router.navigate(['/signin'], {
        queryParams: { previousurl: state.url },
      });
      false;
    }

    if (userDetails.userTypeId !== 2) {
      this.router.navigate(['/creator/emeetings']);
      return false;
    }

    // console.log('userDetails in FanGuard: ', userDetails);
    return true;
  }
}
